<script setup>
import { useStore } from 'vuex';
const store = useStore();
defineEmits(['change']);
</script>
<template>
  <div class="bg-light p-4 shadow-sm mb-4">
    <h2 class="card-title h3 mb-3">Scegli la modalità dell'appuntamento</h2>
    <div class="d-flex flex-column flex-md-row" style="gap: 2rem;">
      <div class="form-check bg-white p-4 w-100">
        <input name="erogationMode" type="radio" id="erogationFis" :checked="store.state.erogationMode !== 'vir'" @change="() => { $emit('change', 'fis') }">
        <label for="erogationFis"><h5>Fisica</h5><b>Si svolgerà fisicamente nella sede specificata nel servizio</b></label>
      </div>
      <div class="form-check bg-white p-4 w-100">
        <input name="erogationMode" type="radio" id="erogationVir" :checked="store.state.erogationMode === 'vir'" @change="() => { $emit('change', 'vir') }">
        <label for="erogationVir"><h5>Virtuale</h5><b>Riceverai il link a cui collegarti alla conclusione della prenotazione</b></label>
      </div>
    </div>
  </div>
</template>
